import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';
import { TableEvent } from 'src/app/shared/components/table/Itable';
import { FnPaymentDetailsComponent } from '../fn-payment-details/fn-payment-details.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-fn-payments-done',
  templateUrl: './fn-payments-done.component.html',
  styleUrls: ['./fn-payments-done.component.scss'],
})
export class FnPaymentsDoneComponent implements OnInit {
  tableOptions!: TableOption;
  type!: 'business' | 'employee' | 'provider';
  propertyOrder: string[] = [];

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private roleService: IpRoleService,
    private breakpointObserver: BreakpointObserver,
    private translateService: TranslateService,
    private ipSnackbarService: IpSnackbarService
  ) {}

  async ngOnInit(): Promise<void> {
    this.type = this.roleService.getType();
    this.propertyOrder = this.setProperty();

    this.tableOptions = {
      keyTranslate: this.setKeyTranslate(),
      selects: [],
      actions: this.setActions(),
      filters: this.setFilters(),
    };
  }

  setKeyTranslate(): string {
    return 'IP.TABLE.PAYMENTS-DONE';
  }

  setFilters(): Array<[string, string]> {
    switch (this.type) {
      case 'business':
      case 'provider':
        return [['IP.TABLE.DASHBOARD.FILTER.DATE-ISSUED', 'date']];
      default:
        return [];
    }
  }

  setProperty(): string[] {
    switch (this.type) {
      case 'business':
        return [
          'provider_name',
          'idConsolidate',
          'date',
          'amount',
          'accNumber',
        ];
      default:
        return [];
    }
  }

  setActions(): Array<string> {
    switch (this.type) {
      case 'business':
        return ['search'];
      default:
        return [];
    }
  }

  async onAction(tableEvent: TableEvent) {
    switch (tableEvent.event) {
      case 'search':
        const { width, minWidth } = this.getDialogDimensions();

        const dialogRef = this.dialog.open(FnPaymentDetailsComponent, {
          height: 'max-content',
          minHeight: '400px',
          maxHeight: '800px',
          width: width,
          minWidth: minWidth,
          panelClass: 'custom-modal',
          data: tableEvent.dataField,
        });

        dialogRef.disableClose = true;

        break;
    }
  }

  private getDialogDimensions() {
    if (this.breakpointObserver.isMatched(Breakpoints.Web)) {
      return { width: 'max-content', minWidth: '50%' };
    } else {
      return { width: 'max-content', minWidth: '80%' };
    }
  }
}
